import type { ReactNode } from 'react';

import { legacyTheme, styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

const GridWrapper = styled.section<{ background: string }>`
  display: flex;
  flex-flow: column;
  width: 100%;
  padding: ${legacyTheme.spacing.s72} 0;

  background: ${({ background }) => background};

  ${legacyTheme.breakpoints.up('sm')} {
    padding: ${legacyTheme.spacing.s144} 0;
  }
`;

const GridContent = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  margin: auto;
  max-width: 1200px;

  box-sizing: border-box;

  &:last-child {
    margin-bottom: 0;
  }

  ${legacyTheme.breakpoints.up('sm')} {
    flex-flow: row wrap;

    &:last-child {
      margin-bottom: initial;
    }
  }
`;

type GridProps = {
  background?: string;
  children: ReactNode;
  dataTestId?: string;
  title?: string;
  titleMarkupName?: 'h2' | 'p';
};

export const GridReviews = ({
  background = 'white',
  children,
  dataTestId = '',
  title = '',
  titleMarkupName = 'p',
}: GridProps) => (
  <GridWrapper background={background} data-testid={dataTestId}>
    {title && (
      <Typography align="center" markupName={titleMarkupName} variant="mono1">
        {title}
      </Typography>
    )}
    <GridContent>{children}</GridContent>
  </GridWrapper>
);
